const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendingRedeemIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "url(#paint0_linear_3346_15738)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.91662 8.52299C10.7199 7.81459 11.7747 7.38402 12.9294 7.38402C15.4443 7.38402 17.4865 9.42625 17.4865 11.9412C17.4865 14.4561 15.4443 16.4983 12.9294 16.4983C11.7747 16.4983 10.7199 16.0677 9.91662 15.3593C9.72176 15.1871 9.42319 15.2053 9.25096 15.4008C9.07873 15.5957 9.09759 15.8936 9.29245 16.0658C10.2623 16.922 11.5358 17.4412 12.9294 17.4412C15.9647 17.4412 18.4294 14.9765 18.4294 11.9412C18.4294 8.90579 15.9647 6.44116 12.9294 6.44116C11.5358 6.44116 10.2623 6.96036 9.29245 7.81648C9.09759 7.98871 9.07873 8.28665 9.25096 8.4815C9.42319 8.67699 9.72176 8.69522 9.91662 8.52299Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2065 9.17553V11.6898C12.2065 11.8149 12.2562 11.935 12.3448 12.023L14.3563 14.0344C14.5398 14.2186 14.839 14.2186 15.0225 14.0344C15.2067 13.8508 15.2067 13.5516 15.0225 13.3681L13.1494 11.4943V9.17553C13.1494 8.9153 12.9382 8.7041 12.678 8.7041C12.4177 8.7041 12.2065 8.9153 12.2065 9.17553Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.38653 10.2124H9.15796C9.41819 10.2124 9.62939 10.0012 9.62939 9.74096C9.62939 9.48073 9.41819 9.26953 9.15796 9.26953H5.38653C5.1263 9.26953 4.9151 9.48073 4.9151 9.74096C4.9151 10.0012 5.1263 10.2124 5.38653 10.2124Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.01507 12.4123H9.7865C10.0467 12.4123 10.2579 12.2011 10.2579 11.9409C10.2579 11.6807 10.0467 11.4695 9.7865 11.4695H6.01507C5.75484 11.4695 5.54364 11.6807 5.54364 11.9409C5.54364 12.2011 5.75484 12.4123 6.01507 12.4123Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.64367 14.6125H10.4151C10.6753 14.6125 10.8865 14.4013 10.8865 14.1411C10.8865 13.8809 10.6753 13.6697 10.4151 13.6697H6.64367C6.38344 13.6697 6.17224 13.8809 6.17224 14.1411C6.17224 14.4013 6.38344 14.6125 6.64367 14.6125Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3346_15738",
    x1: 5.55719,
    y1: 0.531419,
    x2: 20.1251,
    y2: 24.9846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFB88D",
    style: {
      stopColor: "#CFB88D",
      stopColor: "color(display-p3 0.8118 0.7216 0.5529)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59462E",
    style: {
      stopColor: "#59462E",
      stopColor: "color(display-p3 0.3490 0.2745 0.1804)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingRedeemIcon);
export default __webpack_public_path__ + "static/media/PendingRedeemIcon.b531f8583a018b5059699e3f37694fe9.svg";
export { ForwardRef as ReactComponent };